import {SODeleteAssignedProject} from '../../core/assigned-project/so-delete-assigned-project';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteAssignedProject extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteAssignedProject;
}